import { Palette } from "lucide-react";
import { Card, Spinner } from "@/components/common";
import { InterfaceSetting } from "@/components/studio/InterfaceChoice";
import {
  usePersonalization,
  useUpdatePersonalization,
} from "@/hooks/useSettings";
import type { ThemeOption } from "@/types/settings";
import { ThemeCard } from "./ThemeCard";

const themes: { value: ThemeOption; label: string; description: string }[] = [
  {
    value: "light",
    label: "Jasny",
    description: "Domyślny jasny motyw",
  },
  {
    value: "dark",
    label: "Ciemny",
    description: "Motyw dla pracy w ciemności",
  },
  {
    value: "system",
    label: "Systemowy",
    description: "Dopasuj do ustawień systemu",
  },
];

export function PersonalizationTab() {
  const { data: prefs, isLoading } = usePersonalization();
  const updatePrefs = useUpdatePersonalization();

  if (isLoading || !prefs) {
    return (
      <div className="flex justify-center py-12">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <InterfaceSetting />
      <Card>
        <div className="mb-4 flex items-start gap-3">
          <div className="rounded-lg bg-adara-50 p-2 text-adara-700 dark:bg-adara-900/30 dark:text-adara-300">
            <Palette size={20} aria-hidden="true" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-main">Motyw aplikacji</h3>
            <p className="mt-1 text-xs text-dim">
              Wybierz preferowany wygląd interfejsu
            </p>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-3">
          {themes.map((theme) => (
            <ThemeCard
              key={theme.value}
              theme={theme.value}
              label={theme.label}
              description={theme.description}
              isSelected={prefs.theme === theme.value}
              onSelect={() => {
                updatePrefs.mutate({ theme: theme.value });
              }}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}
